import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { from, map, Observable, switchMap, tap } from "rxjs";
import { IndexedDBService } from "../../services/indexed-db.service";
import { isArray } from "highcharts";

@Injectable()
export class ChatResponseInterceptor implements HttpInterceptor {
  indexedDB = inject(IndexedDBService);
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      switchMap(event => {
        return new Observable<HttpEvent<any>>(observer => {
          if (event instanceof HttpResponse && req.url.includes('/chats') && req.method === 'GET') {
            const chatId = this.extractChatId(req.url);
            if (!chatId) {
              observer.next(event);
              observer.complete();
            } else {
              const chat = event.body;
              this.indexedDB.read('messages', this.getCommentableKey(chat.document_type,chat.document_id), 'commentable').then(savedMessages => {
                savedMessages = savedMessages || [];
                for (const message of chat.comments) {
                  message.chat_id = parseInt(chatId);
                  this.indexedDB.write('messages', message);
                }
                    
                if (event instanceof HttpResponse) {
                  event = event.clone({
                    body: {
                      ...event.body,
                      comments: this.mergeMessages(savedMessages,chat.comments).sort((a, b) => {
                        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
                      })
                    }
                  });
                  observer.next(event);
                  observer.complete();
                }
              })
            }
          } 
          else {
            observer.next(event);
            observer.complete();
          }
        });
        
      })
    );
  }
  private extractChatId(url: string): string {
    // Extrae el ID del chat de la URL
    const match = url.match(/\/chats\/(\d+)/);
    return match ? match[1] : '';
  }
  private getCommentableKey(type,id){
    return [type,parseInt(id)]
  }

  private mergeMessages(old,new_messages){
    const merged = [...old];
    for (const message of new_messages) {
      const index = merged.findIndex(m => m.id === message.id);
      if (index === -1) {
        merged.push(message);
      } else {
        merged[index] = message;
      }
    }
    return merged;
  }
}